import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { RSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportCreditBureau, sortR } from '../../constants';
import { getCreditBureauReport, getAllCreditBureauReport } from '../../actions';
import { makeGetListCreditBureau, makeGetListAllCreditBureau } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
  downloadStringToFile,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class CreditBureau extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listCreditBureau: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listCreditBureau: props.listCreditBureau,
      totalCount: getPageTotalCount({ ...state, items: props.listCreditBureau }),
    };
  }

  componentDidMount() {
    this.doGetListCreditBureau();
    const {
      permissions: { modeGetCreditBureauReport },
    } = this.props;
    if (modeGetCreditBureauReport) {
      this.doGetListCreditBureau();
      // this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListCreditBureau();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListCreditBureau());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListCreditBureau());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListCreditBureau();
    });
  };

  doGetListCreditBureau = () => {
    const { filter, page, size, sorted } = this.state;
    const { getCreditBureauReport } = this.props;
    const newFilter = cloneDeep(filter);

    if (newFilter.monthYear) {
      newFilter.monthYear = moment(newFilter.monthYear, 'MM-YYYY')
        .format('MMM-YYYY')
        .toUpperCase();
    }
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort: !isEmpty(sorted) && sortR[sorted.sortCol] ? sortR[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getCreditBureauReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistCreditBureau = cb => {
    const { filter, sorted } = this.state;
    const { getAllCreditBureauReport } = this.props;
    const newFilter = cloneDeep(filter);

    if (newFilter.monthYear) {
      newFilter.monthYear = moment(newFilter.monthYear, 'MM-YYYY')
        .format('MMM-YYYY')
        .toUpperCase();
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortR[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllCreditBureauReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistCreditBureau(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllCreditBureau, t } = this.props;
        convertJson2Pdf({
          data: listAllCreditBureau,
          t,
          title: t('reportPage:sidebar.creditBureau').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.creditBureau')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  onExportTextFile = () => {
    this.doGetAlllistCreditBureau(() => {
      const { listAllCreditBureau, t } = this.props;
      const stringConvert = [];
      if (listAllCreditBureau && listAllCreditBureau.length) {
        listAllCreditBureau.forEach(val => {
          if (val.description) {
            stringConvert.push(val.description);
          }
        });
      }
      downloadStringToFile({
        text: stringConvert.join('\r\n'),
        fileType: 'text/plain',
        fileName: `${t('reportPage:sidebar.creditBureau')
          .toLocaleLowerCase()
          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
      });
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistCreditBureau(() => {
      const { listAllCreditBureau, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_CREDIT_BUREAU_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.creditBureau')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.creditBureau')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllCreditBureau,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { jobType: 'jobTypes', jobStatus: 'jobStatus' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllCreditBureau,
          t,
          title: t('reportPage:sidebar.creditBureau').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.creditBureau')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.creditBureau')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('COMMISSIONS_COLLECTIONS_EXTRACTS', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportCreditBureau,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listCreditBureau,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllCreditBureau,
      t,
      permissions: { modeGetCreditBureauReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetCreditBureauReport) return '';
    const exportColumns = exportColumnsSave || {};
    // tableColumnsOutput = exportColumns?.targetFields?.items || [];
    tableColumnsOutput = tabelColumnExportCreditBureau || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.creditBureau') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.creditBureau')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <RSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  {/* <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    <i className="ti-list" />
                  </button> */}
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.creditBureau').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllCreditBureau,
                          t,
                          title: t('reportPage:sidebar.creditBureau').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.creditBureau')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                      <button
                        type="button"
                        id="embrix-btn-export"
                        className="button x-small mr-3 mt-0 float-right"
                        onClick={this.onExportTextFile}
                      >
                        <i className="fa fa-download mr-2" />
                        {t('label.text')}
                      </button>
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listCreditBureau}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listCreditBureau && listCreditBureau.length ? listCreditBureau : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        {/* <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem> */}
      </div>
    );
  }
}

CreditBureau.propTypes = {
  getCreditBureauReport: PropTypes.func,
  getAllCreditBureauReport: PropTypes.func,
  listAllCreditBureau: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

CreditBureau.defaultProps = {
  getCreditBureauReport: () => {},
  getAllCreditBureauReport: () => {},
  listAllCreditBureau: [],
};

const mapStateToProps = createStructuredSelector({
  listCreditBureau: makeGetListCreditBureau() || [],
  listAllCreditBureau: makeGetListAllCreditBureau() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getCreditBureauReport,
    getAllCreditBureauReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(CreditBureau)
);
